export class Cols {
  public header: string;
  public field: string;
  public format?: (value, item) => void;
  tooltip?: (value, item) => void; // (value, item) => {} ;
  sortable?: boolean;
  filterable?: boolean;
  sort?: (a, b, order) => void;
  export?: (value, item) => void;
  click?: (value, item) => void;
  visible?: boolean;
  id?: string;

  type?: string;
  width?: string;
  constructor(data?) {
    Object.assign(this, data);
  }
}

export class TableColumnsSortableWithSortableLabel extends Cols {
  filterableSortableLabel?: string;
}
